var _style, _g, _g2, _g3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRound01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st117{fill:#FFFFFF;stroke:#010101;stroke-width:3;stroke-miterlimit:10;}\n\t.st116{fill:#FFFFFF;}\n\t.st115{fill:none;stroke:#010101;stroke-width:3;stroke-miterlimit:10;}\n\t.st114{fill:#010101;}\n\t.st113{fill:#FFFFFF;stroke:#010101;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M209.12,128.88v0.04c-0.17,0.07-0.34,0.14-0.52,0.21L209.12,128.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M213.97,128.88v0.04c0.17,0.07,0.34,0.14,0.52,0.21L213.97,128.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M120.14,132.33c-5.06,2.15-7.22,7.95-4.8,12.89c0,0,1.75,3.56,2.6,7.02c2.63,10.73,11.58,73.1,11.58,73.1 c0.78,5.44,2.66,9.95,4.18,10.02s4.26,3.96,6.28,7.34c0,0,0,0,1.72,6.13c2.41,8.58,1.59,14.93,1.24,20.4 c-0.98,15.03,0.95,19.03,0.99,33.38c0.05,18.86-10.39,107.4-10.39,107.4c-0.64,5.46,3.23,10.88,8.6,12.04l28.45,3.21 c5.49,0.26,14.06-1.44,19.04-3.79c0,0,24.95-11.74,26.19-54.91c2.26-78.85-0.32-226.66-0.32-226.66 c-0.1-5.5-0.68-10.2-1.29-10.45c-0.62-0.25-2.18-0.6-2.18-0.24c0,0.35-4.33-0.58-9.62-2.08l-14.59-7.92 c-3.65-4.11-6.83-7.9-7.05-8.42s-0.59-1.73-0.59-2.55s-4.14,0.26-9.2,2.41L120.14,132.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M120.14,132.33c-5.06,2.15-7.22,7.95-4.8,12.89c0,0,1.75,3.56,2.6,7.02c2.63,10.73,11.58,73.1,11.58,73.1 c0.78,5.44,2.66,9.95,4.18,10.02s4.26,3.96,6.28,7.34c0,0,0,0,1.72,6.13c2.41,8.58,1.59,14.93,1.24,20.4 c-0.98,15.03,0.95,19.03,0.99,33.38c0.05,18.86-10.39,107.4-10.39,107.4c-0.64,5.46,3.23,10.88,8.6,12.04l28.45,3.21 c5.49,0.26,14.06-1.44,19.04-3.79c0,0,24.95-11.74,26.19-54.91c2.26-78.85-0.32-226.66-0.32-226.66 c-0.1-5.5-0.68-10.2-1.29-10.45c-0.62-0.25-2.18-0.6-2.18-0.24c0,0.35-4.33-0.58-9.62-2.08l-14.59-7.92 c-3.65-4.11-6.83-7.9-7.05-8.42s-0.59-1.73-0.59-2.55s-4.14,0.26-9.2,2.41L120.14,132.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M92.08,410.25c0.11,5.5,4.7,10,10.2,10h14.66c5.5,0,10-4.5,9.99-10c0,0-0.05-94.73,7.35-152 c0.98-7.58,2.04-15.08,3.17-22.49c0.16-1.06,0.16-1.06,0.16-1.06c0.18-1.17-0.35-6.57-1.17-12.01c0,0-9.42-62.04-12.05-72.77 c-0.85-3.46-3-11.97-6.32-13.71c-0.26-0.14-0.52-0.24-0.79-0.29c-1.94-0.36-1.94-0.36-1.94-0.36c-1.56,2.64-3.61,9.23-4.55,14.65 c0,0-12.1,69.66-15.85,115.37C90.3,322.28,92.08,410.25,92.08,410.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M92.08,410.25c0.11,5.5,4.7,10,10.2,10h14.66c5.5,0,10-4.5,9.99-10c0,0-0.05-94.73,7.35-152 c0.98-7.58,2.04-15.08,3.17-22.49c0.16-1.06,0.16-1.06,0.16-1.06c0.18-1.17-0.35-6.57-1.17-12.01c0,0-9.42-62.04-12.05-72.77 c-0.85-3.46-3-11.97-6.32-13.71c-0.26-0.14-0.52-0.24-0.79-0.29c-1.94-0.36-1.94-0.36-1.94-0.36c-1.56,2.64-3.61,9.23-4.55,14.65 c0,0-12.1,69.66-15.85,115.37C90.3,322.28,92.08,410.25,92.08,410.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M302.86,132.33c5.06,2.15,7.22,7.95,4.8,12.89c0,0-1.75,3.56-2.6,7.02c-2.63,10.73-11.58,73.1-11.58,73.1 c-0.78,5.44-2.66,9.95-4.18,10.02c-1.52,0.07-4.26,3.96-6.28,7.34c0,0,0,0-1.72,6.13c-2.41,8.58-1.59,14.93-1.24,20.4 c0.98,15.03-0.95,19.03-0.99,33.38c-0.05,18.86,10.39,107.4,10.39,107.4c0.64,5.46-3.23,10.88-8.6,12.04l-28.45,3.21 c-5.49,0.26-14.06-1.44-19.04-3.79c0,0-24.95-11.74-26.19-54.91c-2.26-78.85,0.32-226.66,0.32-226.66 c0.1-5.5,0.68-10.2,1.29-10.45c0.62-0.25,2.18-0.6,2.18-0.24c0,0.35,4.33-0.58,9.62-2.08l14.59-7.92 c3.65-4.11,6.83-7.9,7.05-8.42s0.59-1.73,0.59-2.55s4.14,0.26,9.2,2.41L302.86,132.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M302.86,132.33c5.06,2.15,7.22,7.95,4.8,12.89c0,0-1.75,3.56-2.6,7.02c-2.63,10.73-11.58,73.1-11.58,73.1 c-0.78,5.44-2.66,9.95-4.18,10.02c-1.52,0.07-4.26,3.96-6.28,7.34c0,0,0,0-1.72,6.13c-2.41,8.58-1.59,14.93-1.24,20.4 c0.98,15.03-0.95,19.03-0.99,33.38c-0.05,18.86,10.39,107.4,10.39,107.4c0.64,5.46-3.23,10.88-8.6,12.04l-28.45,3.21 c-5.49,0.26-14.06-1.44-19.04-3.79c0,0-24.95-11.74-26.19-54.91c-2.26-78.85,0.32-226.66,0.32-226.66 c0.1-5.5,0.68-10.2,1.29-10.45c0.62-0.25,2.18-0.6,2.18-0.24c0,0.35,4.33-0.58,9.62-2.08l14.59-7.92 c3.65-4.11,6.83-7.9,7.05-8.42s0.59-1.73,0.59-2.55s4.14,0.26,9.2,2.41L302.86,132.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M330.92,410.25c-0.11,5.5-4.7,10-10.2,10h-14.66c-5.5,0-10-4.5-9.99-10c0,0,0.05-94.73-7.35-152 c-0.98-7.58-2.04-15.08-3.17-22.49c-0.16-1.06-0.16-1.06-0.16-1.06c-0.18-1.17,0.35-6.57,1.17-12.01c0,0,9.42-62.04,12.05-72.77 c0.85-3.46,3-11.97,6.32-13.71c0.26-0.14,0.52-0.24,0.79-0.29c1.94-0.36,1.94-0.36,1.94-0.36c1.56,2.64,3.61,9.23,4.55,14.65 c0,0,12.1,69.66,15.85,115.37C332.7,322.28,330.92,410.25,330.92,410.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M330.92,410.25c-0.11,5.5-4.7,10-10.2,10h-14.66c-5.5,0-10-4.5-9.99-10c0,0,0.05-94.73-7.35-152 c-0.98-7.58-2.04-15.08-3.17-22.49c-0.16-1.06-0.16-1.06-0.16-1.06c-0.18-1.17,0.35-6.57,1.17-12.01c0,0,9.42-62.04,12.05-72.77 c0.85-3.46,3-11.97,6.32-13.71c0.26-0.14,0.52-0.24,0.79-0.29c1.94-0.36,1.94-0.36,1.94-0.36c1.56,2.64,3.61,9.23,4.55,14.65 c0,0,12.1,69.66,15.85,115.37C332.7,322.28,330.92,410.25,330.92,410.25z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st114",
    cx: 217.08,
    cy: 271.94,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st114",
    cx: 217.08,
    cy: 316.34,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st114",
    cx: 217.08,
    cy: 360.74,
    r: 5
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st114",
    cx: 217.08,
    cy: 138.74,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st114",
    cx: 217.08,
    cy: 183.14,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st114",
    cx: 217.08,
    cy: 227.54,
    r: 5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M179.41,103.74l-1,2c0.04,0.19-0.05,0.81,0,1c2.93,14.03,16.77,21.63,31.85,22.13v-12.81 c-11.72-0.38-23.43-6.88-28.72-16.32C180.41,100.74,180.41,101.74,179.41,103.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M243.26,103.74l1,2c-0.04,0.19,0.05,0.81,0,1c-2.93,14.03-16.77,21.63-31.85,22.13v-12.81 c11.72-0.38,23.43-6.88,28.72-16.32C242.26,100.74,242.26,101.74,243.26,103.74z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "280.44,334.41 280.31,334.42 279.33,315.41 241.99,316.74 241.99,314.3 279.33,312.96  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M280.44,336.85l-31.23,2.54c-3.89,0.32-7.22-2.75-7.22-6.65v-16l37.34-1.33l0.98,19.01L280.44,336.85z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st113",
    x1: 256.88,
    y1: 233.75,
    x2: 255.77,
    y2: 312.97
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "142.99,335.41 143.12,335.42 144.1,316.41 181.44,317.74 181.44,315.3 144.1,313.96  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M142.99,337.85l31.23,2.54c3.89,0.32,7.22-2.75,7.22-6.65v-16l-37.34-1.33l-0.98,19.01L142.99,337.85z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st113",
    x1: 166.55,
    y1: 234.75,
    x2: 167.66,
    y2: 313.97
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M239.06,178.99c9.7-0.37,28.3-2.39,38-2.76c0,3.63,0,7.26,0,10.89c-12.07,1.19-28.93,2.68-41,3.87 C237.06,185.99,238.06,182.99,239.06,178.99z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRound01);
export default __webpack_public_path__ + "static/media/ROUND-01.3ec4262dc7fd89741a2c5b220a2c062c.svg";
export { ForwardRef as ReactComponent };